import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GiftCard, TicketBarcodes} from '../../generated/sales-terminal-client';
import {SnackService} from '../../services/snack/snack.service';
import {TranslateService} from '@ngx-translate/core';
import {UtilService} from "../../services/util/util.service";
import {CartAdvancedInterface} from '../../services/cart/cart.interface';
import {tap} from 'rxjs';

@Component({
  selector: 'app-gift-code',
  templateUrl: './gift-code.component.html',
  styleUrls: ['./gift-code.component.scss']
})
export class GiftCodeComponent<Type> {
  @Input() service: CartAdvancedInterface<Type>;
  @Input() disabled: boolean;

  private _giftCode: string;
  @Input()
  set giftCode(value: string) {
    this._giftCode = value;
    this.giftCodeChange.emit(value);
  }
  get giftCode(): string {
    return this._giftCode;
  }
  @Output() public giftCodeChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private snackService: SnackService,
              private translateService: TranslateService,
              public utilService: UtilService) { }

  public addGiftCode(): void {
    if (this.service.giftCodes.includes(this.giftCode)) {
      this.snackService.showError(this.translateService.instant('general.api_cart_gift_card_already_in_cart'));
    } else {
      if (this.service.isSelfService) {
        this.service.addSelfServiceGiftCode(this.giftCode).pipe(
          tap({error: _ => this.service.retryCart()})
        ).subscribe((result: Type) => this.finishWithGiftCode(result));
      } else {
        this.service.addGiftCodes({codes: [this.giftCode]}).pipe(
          tap({error: _ => this.service.retryCart()})
        ).subscribe((result: Type) => this.finishWithGiftCode(result));
      }
    }
  }
  private finishWithGiftCode(result: Type): void {
    this.service.updateCart(result);
    this.giftCode = '';
  }

  public removeGiftCode(giftCode: GiftCard): void {
    if (this.service.isSelfService) {
      this.service.removeSelfServiceGiftCode(giftCode?.code).pipe(
        tap({error: _ => this.service.retryCart()})
      ).subscribe((result: Type) => this.service.updateCart(result));
    } else {
      this.service.removeGiftCodes({codes: [giftCode.code]}).pipe(
        tap({error: _ => this.service.retryCart()})
      ).subscribe((result: Type) => this.service.updateCart(result));
    }
  }
}
